<template>
<div class="chapter">
<div class="inner_page">
<section class="part" epub:type="part" id="part-001"><span epub:type="pagebreak" id="page_15" title="15"><div class="part_debut"></div><h1 class="part_surtit" epub:type="title"><span><img alt="Illustration" class="image_intext" id="PT_BG_Gray1" src="images/PT_BG_Gray.jpg"/></span></h1></span></section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// p1.vue?76783f0e